import { useMemo } from 'react';

export default function TopicsSection() {
  const topics = useMemo(() => [
    { id: 1, label: '娱乐圈大瓜', hot: true, count: '12.8k' },
    { id: 2, label: '51吃瓜在线', hot: true, count: '10.5k' },
    { id: 3, label: '社会热点追踪', hot: true, count: '9.2k' },
    { id: 4, label: '暗网吃瓜直播', hot: false, count: '8.7k' },
    { id: 5, label: '51cg吃瓜', hot: false, count: '7.3k' },
    { id: 6, label: '网络热议事件', hot: true, count: '6.9k' },
    { id: 7, label: '独家爆料', hot: false, count: '5.8k' },
    { id: 8, label: '吃瓜视频精选', hot: false, count: '5.2k' },
    { id: 9, label: '深夜暗网吃瓜', hot: false, count: '4.6k' },
    { id: 10, label: '在线暗网吃瓜', hot: false, count: '4.1k' },
  ], []);

  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 mt-3">当前最受关注的吃瓜话题，点击探索更多</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#cards"
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-50 text-primary-700 border border-primary-200 hover:bg-primary-100 hover:border-primary-300'
                  : 'bg-background-100 text-foreground-600 border border-background-200/70 hover:bg-background-200 hover:border-foreground-300'
              }`}
            >
              {topic.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
              )}
              <span>{topic.label}</span>
              <span className={`text-xs ${topic.hot ? 'text-primary-400' : 'text-foreground-400'}`}>
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}